var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{attrs:{"id":"card"},on:{"mouseenter":_setup.mouseEnter,"mouseleave":_setup.mouseLeave}},[_c('div',{staticClass:"tw-grid tw-grid-cols-1 tw-gap-3 lg:tw-gap-4"},[_vm._t("image"),_vm._t("category"),_vm._t("titleAndDescription"),_vm._t("callToAction",null,{"hover":_setup.isHovering})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }